import { TARGETS } from "../utils/buildPrompt";

export default function Slider({ target, value, onChange }) {
  const levels = TARGETS[target].levels.filter(l => l);
  const pct = levels.length > 1 ? (value / (levels.length - 1)) * 100 : 0;
  return (
    <div style={{ animation: 'fadeInUp .2s ease', marginTop: 18 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 10 }}>
        <span style={{ fontSize: 15, color: '#555555', fontWeight: 600 }}>이 사람과 친밀도는?</span>
        <span style={{ fontSize: 13, fontWeight: 700, background: '#111111', color: '#ffffff', padding: '2px 10px', borderRadius: 8 }}>{levels[value]}</span>
      </div>
      <div style={{ padding: '0 4px', marginBottom: 8 }}>
        <input type="range" min={0} max={levels.length - 1} value={value}
          onChange={e => onChange(Number(e.target.value))}
          style={{ background: `linear-gradient(to right, #111111 0%, #111111 ${pct}%, #e0e0e0 ${pct}%, #e0e0e0 100%)` }}
        />
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0 2px' }}>
        {levels.map((lv, i) => (
          <span key={i} onClick={() => onChange(i)} style={{ fontSize: 13, color: i === value ? '#111111' : '#888888', fontWeight: i === value ? 700 : 400, cursor: 'pointer', transition: 'all .1s' }}>{lv}</span>
        ))}
      </div>
    </div>
  );
}